<template>
	<ul class="list-none space-y-4" :class="[`col-count-${columnsCount}`]">
		<template v-for="(item, index) in items" :key="index">
			<li v-if="item.value" class="relative">
				<slot :item="item" :index="index">
					<div class="flex" :class="columnGap">
						<div
							v-if="item.label"
							:class="[columnWidth, firstColumnClass]"
						>
							{{ item.label }}
						</div>
						<div class="w-full" :class="secondColumnClass">
							<slot :name="`value-${_kebabCase(item.label)}`">
								{{ item.value }}
							</slot>
						</div>
					</div>
				</slot>
			</li>
		</template>
	</ul>
</template>

<script setup>
import { kebabCase as _kebabCase } from 'lodash-es'

const props = defineProps({
	items: {
		type: Array,
		required: true,
	},
	columnsCount: {
		type: Number,
		required: false,
		default: 1,
	},
	columnWidth: {
		type: String,
		required: false,
		default: 'w-6/12',
	},
	columnGap: {
		type: String,
		required: false,
		default: '',
	},
	firstColumnClass: {
		type: String,
		required: false,
		default: 'font-medium',
	},
	secondColumnClass: {
		type: String,
		required: false,
		default: 'text-gray-575',
	},
})
</script>
